import "core-js/modules/es7.array.includes.js";
import BOT_USER_AGENTS from '~/const/botUserAgent';
var isSearchEngine = agent => !!BOT_USER_AGENTS.find(bot => agent && agent.toLowerCase().includes(bot.toLowerCase()));
export default isSearchEngine;